module.exports = __webpack_public_path__ + "img/prio-eletric.97c84944.png";